<template>
  <div class="m-1">
    <div class="d-flex justify-content-center">
      <div class="d-flex row">
        <WCProductDetailsImage :item="item" :scanMode="true" class="mr-3" />
        <div>
          <span>{{ item.name }} {{ item.brand }} </span>
          <WCProductPricing :item="item" />
        </div>
      </div>
    </div>

    <p class="m-2 font-weight-bold">
      {{ $t('infoRequiredSingleOrMultiItem') }}
    </p>

    <div class="d-flex">
      <button class="btn btn-primary btn-block m-2 custom-select-sm" @click="selectItem(item)">
        {{ $t('singleItem') }}
      </button>

      <select
        class="btn btn-primary  btn-block m-2 custom-select-sm"
        style="max-width:50%;"
        @change="itemPackSelected"
      >
        <option disabled selected value=""> {{ $t('itemPack') }}</option>
        <option
          v-for="altId in alternateIds"
          :key="altId.id"
          :value="altId.id"
          :data-option="altId.id"
        >
          {{ altId.name }}
          <span v-if="altId.ascQuantity">- {{ $t('packOf') }} {{ altId.ascQuantity }}</span>
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import WCProductDetailsImage from '@/modules/lists/components/WCProductDetailsImage/WCProductDetailsImage.vue';
import WCProductPricing from '@/components/WCProductPricing/WCProductPricing.vue';
import ProductImageInfoMixin from '@/mixins/ProductImageInfoMixin';

export default {
  props: {
    alternateIds: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    WCProductDetailsImage,
    WCProductPricing,
  },
  mixins: [ProductImageInfoMixin],
  methods: {
    selectItem(item) {
      this.$emit('selectItem', item);
    },
    itemPackSelected(event) {
      const selectedItemId = event.target.value;
      const selectedItem = this.alternateIds.find(altId => altId.id === selectedItemId);
      this.$emit('selectItem', selectedItem);
    },
  },
};
</script>
